import { defineComponent as _defineComponent } from 'vue'
import { EoiDetails, Lot } from "@/types/CustomerLotDetails";
  import { ref } from "vue";
  import { EoiStatus } from "@/enums/EoiStatus";
  import { LotStatus } from "@/enums/LotStatus";
  import Modal from "@/components/ui/Modal.vue";
  import router from "@/router";
  import store from "@/store";
  import { POSITION, useToast } from "vue-toastification";
  import { showingEoiDetailControls } from "@/helpers/customer";
  import { getUser } from "@/features/useUser";
  import { UserRoles } from "@/enums/UserRoles";

  interface Props {
    eoiDetails: EoiDetails;
    lot: Lot;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerLotEoiDetails',
  props: {
    eoiDetails: {},
    lot: {}
  },
  emits: ["onWithdraw", "changeTab"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const toast = useToast();
  const props = __props;
  const emits = __emit;
  const { PENDING_FOR_BILLING, DRAFT } = EoiStatus;
  const showConfirmDeleteModal = ref(false);
  const modalInfo = ref({
    title: "",
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    action: () => {},
  });

  function showingControls() {
    return showingEoiDetailControls(
      props.eoiDetails.status as EoiStatus,
      props.lot.status as LotStatus
    );
  }
  function onWithdraw() {
    modalInfo.value = {
      title: props.lot.estate.isRefundable
        ? "Are you sure you want to withdraw this reservation?"
        : "Are you sure you want to withdraw this reservation? Please note that the holding deposit for this lot is non-refundable",
      action: withDrawEoi,
    };
    showConfirmDeleteModal.value = true;
  }
  function onDecline() {
    modalInfo.value = {
      title: "Are you sure you want to cancel this reservation?",
      action: declineEoi,
    };
    showConfirmDeleteModal.value = true;
  }
  function onDelete() {
    modalInfo.value = {
      title: "Are you sure you want to delete this reservation?",
      action: deleteEoi,
    };
    showConfirmDeleteModal.value = true;
  }
  function declineEoi() {
    store
      .dispatch("eoi/declineEoi", {
        moneyHoldId: props.eoiDetails.moneyHoldId,
        eoiId: props.eoiDetails.id,
      })
      .then(() => {
        toast.success("Reservation was successfully declined", {
          position: POSITION.TOP_LEFT,
        });
        emits("changeTab", "activity");
        emits("onWithdraw");
      })
      .catch(() => {
        toast.error("Something went wrong", {
          position: POSITION.TOP_LEFT,
        });
      });
  }
  function deleteEoi() {
    store
      .dispatch("eoi/deleteEoi", props.eoiDetails.id)
      .then(() => {
        router.push({ name: "CustomerLots" });
        toast.success("Contract form was successfully deleted", {
          position: POSITION.TOP_LEFT,
        });
      })
      .catch(() => {
        toast.error("Something went wrong", {
          position: POSITION.TOP_LEFT,
        });
      });
  }
  function withDrawEoi() {
    store
      .dispatch("eoi/revokeEoi", {
        eoiId: props.eoiDetails.id,
        lotId: props.lot.id,
      })
      .then(() => {
        emits("onWithdraw");
        toast.success("Reservation was successfully withdrawn", {
          position: POSITION.TOP_LEFT,
        });
      })
      .catch(() => {
        toast.error("Something went wrong", {
          position: POSITION.TOP_LEFT,
        });
      });
  }
  function dynamicDelete() {
    modalInfo.value.action();
    showConfirmDeleteModal.value = false;
  }
  function onComplete() {
    if ((props.eoiDetails.status as EoiStatus) === DRAFT) {
      router.push({
        name: "EOIRequest",
        params: {
          estateId: props.lot.estate.id,
          lotId: props.lot.id,
          backUrl: router.currentRoute.value.path,
        },
        query: {
          eoiId: props.eoiDetails.id,
        },
      });
    }

    if ((props.eoiDetails.status as EoiStatus) === PENDING_FOR_BILLING) {
      router.push({
        name: "EOIRequestPayment",
        params: {
          eoiId: props.eoiDetails.id,
          estateId: props.lot.estate.id,
          lotId: props.lot.id,
          backUrl: router.currentRoute.value.path,
        },
      });
    }
  }

const __returned__ = { toast, props, emits, PENDING_FOR_BILLING, DRAFT, showConfirmDeleteModal, modalInfo, showingControls, onWithdraw, onDecline, onDelete, declineEoi, deleteEoi, withDrawEoi, dynamicDelete, onComplete, get EoiDetails() { return EoiDetails }, get Lot() { return Lot }, ref, get EoiStatus() { return EoiStatus }, get LotStatus() { return LotStatus }, Modal, get router() { return router }, get store() { return store }, get POSITION() { return POSITION }, get useToast() { return useToast }, get showingEoiDetailControls() { return showingEoiDetailControls }, get getUser() { return getUser }, get UserRoles() { return UserRoles } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})